const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getClientToken = () => localStorage.getItem('client_portal_token');
export const setClientToken = (token) => localStorage.setItem('client_portal_token', token);
export const clearClientToken = () => localStorage.removeItem('client_portal_token');

// Every client-portal call goes through this so a 401 (expired/invalid
// token) always sends the client back to login instead of showing a
// confusing half-loaded screen.
export const clientPortalFetch = async (path, options = {}) => {
  const token = getClientToken();
  const res = await fetch(`${BASE}/api/client-portal${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    clearClientToken();
    window.location.href = '/client-portal/login';
    throw new Error('Session expired');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Something went wrong');
  return data;
};
